mergeOptions